<div class="dialog-select-reservation-facilities" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div class="title-letter" fxLayout="row" fxLayoutGap="10px">
        <mat-icon>search</mat-icon>
        <span>{{'予約施設リスト' | translate}}</span>
      </div>

      <button mat-button (click)="onNoClick()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div class="filter-field" fxLayout="row" fxLayoutGap="20px">
    <mat-form-field fxFlex="25%">
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
    </mat-form-field>
    <mat-form-field fxFlex="15%">
      <mat-select placeholder="{{'属性' | translate}}" id="reservationFacilityAttributeId" (selectionChange)="applyFilterAttr($event)">
        <mat-option [value]= ""></mat-option>
        <mat-option *ngFor="let reservationFacilityAttribute of reservationFacilityAttributes" [value]="reservationFacilityAttribute.attribute_id">
          {{ reservationFacilityAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div mat-dialog-content fxLayout="column" fxLayoutAlign="start center" fxFlex="500px" style="overflow: auto;">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let reservationFacility; let i = index">{{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }}</td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <span> {{'選択' | translate}} </span>
        </th>
        <td mat-cell *matCellDef="let row">
          <button mat-stroked-button color="primary" (click)="selectFunc(row)">{{'選択' | translate}}</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="reservation_facility_id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let reservationFacility"> {{ reservationFacility.reservation_facility_id }} </td>
      </ng-container>

      <ng-container matColumnDef="attribute">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'属性' | translate}} </th>
        <td mat-cell *matCellDef="let reservationFacility">
          <span *ngFor="let attribute of (reservationFacility.reservation_facility_attribute_id | docsByCond:attrCollectionName:'attribute_id' | async)">
            {{ attribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'名称' | translate}} </th>
        <td mat-cell *matCellDef="let reservationFacility"> {{ reservationFacility.reservation_facility_names | multiName:projectLanguages:projectBaseLang }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator class="page" [pageSizeOptions]="[15, 30, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>

</div>
